import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import microRegionReadAction from './microRegionRead.action.json' with { type: 'json' }

const microRegionReadDefinition = defineReadAutoAction(microRegionReadAction, 'microRegion')

export default microRegionReadDefinition
